import { Injectable } from '@angular/core';
import { SideDialogService } from '../../ecaps-core/side-dialog/side-dialog.service';
import { Item } from '../../projects/models/project-item.model';
import { ValidSize } from '../../selections/models/selection-results/valid-size.model';
import { ProductInfoDialogComponent } from '../dialogs/product-info-dialog/product-info-dialog.component';
import { ProductInfoDialogData } from '../models/product-info-dialog-data.model';
import { ProductInfoDialogReturnTypes } from '../models/product-info-dialog-return-types.model';

@Injectable({
  providedIn: 'root',
})
export class ProductInfoDialog {
  constructor(private sideDialogService: SideDialogService) {}

  show(
    size: ValidSize,
    tab: string = 'information',
    revisionItem?: Item,
    tag?: string,
    quantity?: number
  ): Promise<ProductInfoDialogReturnTypes> {
    const promise = new Promise<ProductInfoDialogReturnTypes>((resolve) => {
      const dialogRef = this.sideDialogService.open<any>(
        ProductInfoDialogComponent,
        {
          disableClose: false,
          autoFocus:
            '.product-info-dialog__content input[formcontrolname="tag"]',
          width: 1000,
          data: new ProductInfoDialogData(
            size,
            tab,
            revisionItem,
            tag,
            quantity
          ),
        }
      );

      const subscription = dialogRef.closed.subscribe(
        (results) => {
          resolve(results);
        },
        null,
        () => {
          subscription.unsubscribe();
        }
      );
    });

    return promise;
  }
}
